import { useEffect, useMemo, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";

export function FlowPipe({ points, getPoints, color, sim, running, circuit = "input", selected, onSelect }) {
  const tube = useRef();
  const particles = useRef();
  const updateAge = useRef(1);
  const curve = useMemo(() => new THREE.CatmullRomCurve3((points || getPoints()).map(p => new THREE.Vector3(...p)), false, "centripetal"), [points, getPoints]);
  const initialGeometry = useMemo(() => new THREE.TubeGeometry(curve, 48, 0.065, 8, false), [curve]);
  const point = useMemo(() => new THREE.Vector3(), []);
  useEffect(() => () => { tube.current?.geometry.dispose(); initialGeometry.dispose(); }, [initialGeometry]);

  useFrame((_, delta) => {
    updateAge.current += delta;
    if (getPoints && updateAge.current > 0.08) {
      curve.points = getPoints().map(p => new THREE.Vector3(...p));
      curve.updateArcLengths();
      const old = tube.current.geometry;
      tube.current.geometry = new THREE.TubeGeometry(curve, 48, 0.065, 8, false);
      if (old !== initialGeometry) old.dispose();
      updateAge.current = 0;
    }
    const active = sim.current[circuit] > 0.005;
    particles.current.visible = active;
    particles.current.children.forEach((particle, i) => {
      curve.getPointAt((sim.current.time * 0.19 + i / 9) % 1, point);
      particle.position.copy(point);
    });
    tube.current.material.emissiveIntensity = selected ? 0.65 : active && running ? 0.24 : 0.04;
  }, -1);

  return (
    <group onClick={event => { event.stopPropagation(); onSelect("pipes"); }}>
      <mesh ref={tube} geometry={initialGeometry}>
        <meshStandardMaterial color={color} emissive={color} roughness={0.35} metalness={0.45} />
      </mesh>
      <group ref={particles}>
        {Array.from({ length: 9 }, (_, i) => (
          <mesh key={i}><sphereGeometry args={[0.095, 8, 8]} /><meshBasicMaterial color={color} toneMapped={false} /></mesh>
        ))}
      </group>
    </group>
  );
}